module.exports = __webpack_public_path__ + "img/4.ad77fb9f.svg";